// extracted by mini-css-extract-plugin
module.exports = {"bullet-class":"AffiliateCarousel_bullet-class__5hi7G","bullet-class-active":"AffiliateCarousel_bullet-class-active__RsQw2"};